export default __webpack_public_path__ + "static/media/img-slider-layout1.29d04eeb.png";